import React from "react";
import { Roles, authorize } from "../../utils/AuthService";
import * as URL from "./../Nav/Routes/Url";
import SidebarNavGroup from "./SidebarNavGroup";
import Dashboard from "./NavLinksCommon/Dashboard";
import Resources from "./NavLinksCommon/Resources";
import Users from "./NavLinksCommon/Users";
import SidebarNavGroupItem from "./SidebarNavGroupItem";
import { navIcons } from "../../images";
import { config } from "../../utils/conf";

export default function OutboundNav(props) {
  const { collapsed, user, customer } = props;

  return (
    <React.Fragment>
      <Dashboard collapsed={collapsed} />

      {/* Orders */}
      <SidebarNavGroup label="Orders" collapsed={collapsed}>
        <SidebarNavGroupItem
          url="/ordering/new"
          label="Place Single Order"
          tooltipText="Place Single Order"
          collapsed={collapsed}
          iconComponent={<navIcons.SingleOrder />}
        />
        <SidebarNavGroupItem
          url="/ordering/new-bulk-order"
          label="Place Bulk Order"
          tooltipText="Place Bulk Order"
          collapsed={collapsed}
          iconComponent={<navIcons.BulkOrder />}
        />
        <SidebarNavGroupItem
          url="/ordering"
          label="Order History"
          tooltipText="Order History"
          collapsed={collapsed}
          iconComponent={<navIcons.OrderHistory />}
        />

        <SidebarNavGroupItem
          url="/ordering/request-quote"
          label="Request a Quote"
          tooltipText="Request a Quote"
          collapsed={collapsed}
          iconComponent={<navIcons.RequestQuote />}
        />

        {authorize(user, Roles.ADMINISTRATOR, Roles.CUSTOMER_SERVICE) && (
          <SidebarNavGroupItem
            url="/logs/order"
            label="Order Logs"
            tooltipText="Order Logs"
            collapsed={collapsed}
            iconComponent={<navIcons.OrderLog />}
          />
        )}
      </SidebarNavGroup>

      <SidebarNavGroup collapsed={collapsed}>
        <SidebarNavGroupItem
          url="/invoicing"
          label="Invoices"
          tooltipText="Invoices"
          collapsed={collapsed}
          iconComponent={<navIcons.Invoice />}
        />
      </SidebarNavGroup>

      <SidebarNavGroup label="Reporting" collapsed={collapsed} isOpen={false}>
        <SidebarNavGroupItem
          url="/reporting/transactions"
          label="Transactions"
          tooltipText="Transactions"
          collapsed={collapsed}
          iconComponent={<navIcons.Transactions />}
        />

        {customer.bulkTransactionEnabled && (
          <SidebarNavGroupItem
            url="/reporting/bulk-transactions"
            label="Bulk Transactions"
            tooltipText="Bulk Transactions"
            collapsed={collapsed}
            iconComponent={<navIcons.BulkOrder />}
          />
        )}

        <SidebarNavGroupItem
          url={URL.REPORTING_TRANSACTIONS_HISTORY}
          label="Transaction History"
          tooltipText="Transaction History"
          collapsed={collapsed}
          iconComponent={<navIcons.TransactionHistory />}
        />

        <SidebarNavGroupItem
          url="/reporting/returns"
          label="Returns"
          tooltipText="Returns"
          collapsed={collapsed}
          iconComponent={<navIcons.Returns />}
        />
      </SidebarNavGroup>

      {config.salesforceUrl && (
        <SidebarNavGroup
          label="Onboarding"
          collapsed={collapsed}
          isOpen={false}
        >
          <SidebarNavGroupItem
            url={URL.CUSTOMER_ONBOARDING_PORTAL}
            externalUrl={config.salesforceUrl}
            label="Customer Onboarding Portal"
            tooltipText="Customer Onboarding Portal"
            collapsed={collapsed}
            iconComponent={<navIcons.Users />}
          />
        </SidebarNavGroup>
      )}

      {customer.batchEnabled && (
        <SidebarNavGroup
          label="Batch History"
          collapsed={collapsed}
          isOpen={false}
        >
          <SidebarNavGroupItem
            url={URL.BULK_ORDER_UPLOAD_HISTORY}
            label="Bulk Order Upload History"
            tooltipText="Bulk Order Upload History"
            collapsed={collapsed}
            iconComponent={<navIcons.BulkUploadHistory />}
          />

          <SidebarNavGroupItem
            url={URL.BULK_TRANSACTION_UPLOAD_HISTORY}
            label="Bulk Transaction Upload History"
            tooltipText="Bulk Transaction Upload History"
            collapsed={collapsed}
            iconComponent={<navIcons.BulkUploadHistory />}
          />
        </SidebarNavGroup>
      )}

      <Resources collapsed={collapsed} />

      {authorize(user, Roles.ADMINISTRATOR, Roles.CUSTOMER_SERVICE) && (
        <SidebarNavGroup
          label="Site Management"
          collapsed={collapsed}
          isOpen={false}
        >
          <SidebarNavGroupItem
            url={URL.SITE_MANAGEMENT_INVENTORY_REVIEW}
            label="Inventory Review"
            tooltipText="Inventory Review"
            collapsed={collapsed}
            iconComponent={<navIcons.Transactions />}
          />
        </SidebarNavGroup>
      )}

      <Users collapsed={collapsed} />
    </React.Fragment>
  );
}
